export const getIdForDropdownButton = (dropdownId) => {
    return `${dropdownId}-button`;
};
export const getIdForDropdownList = (dropdownId) => {
    return `${dropdownId}-list`;
};
export const getIdForDropdownListItem = (dropdownId, option) => {
    return `${dropdownId}-list-item-${option.value}`;
};
export const sortDropdownOptionsAlphabetically = (optionA, optionB, i18n) => {
    return i18n.compareTranslatable(optionA, optionB);
};
//# sourceMappingURL=utils.js.map